import { render, staticRenderFns } from "./UserMessages.vue?vue&type=template&id=e02973de&scoped=true&"
import script from "./UserMessages.vue?vue&type=script&lang=js&"
export * from "./UserMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e02973de",
  null
  
)

export default component.exports